<template>
  <div class="ua-promo-area">
    <h3 class="promo-title">
      product types
    </h3>
    <div class="promo-items">
      <div class="promo-item" v-for="(item, index) in items" :key="index">
        <div class="promo-item-icon">
          <img :src="item.image" :alt="item.title" :title="item.title">
        </div>
        <div class="promo-item-content">
          <h3 class="promo-item-title">
            {{ item.title }}
          </h3>
          <div class="promo-item-rows">
            <div class="promo-item-row" v-for="(row, index) in item.rows" :key="index">
              <div class="caret">&#9679;</div>
              <div class="promo-item-row-content">
                {{ row }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants.js';

export default {
  name: "UAPromoArea",
  data() {
    return {
      items: CONSTANTS.UA_PROMO_AREA
    }
  }
}
</script>

<style lang="scss" scoped>
  #app {
    .ua-promo-area {
      .promo-title {
        text-transform: uppercase;
        font-weight: 300;
        margin: .5em 0;
        font-size: 1.5em;
      }
      .promo-items {
        display: flex;
        flex-direction: column;
        .promo-item {
          display: flex;
          .promo-item-icon img {
            max-height: 3em;
            max-width: 2em;
          }
          .promo-item-content {
            display: flex;
            flex-direction: column;
            margin: 0 .3em .75em .75em;
            .promo-item-title {
              text-transform: uppercase;
              font-weight: 700;
              font-size: 1.2em;
              margin: 0;
            }
            .promo-item-rows {
              .promo-item-row {
                display: flex;
                font-size: 0.75em;
                .caret {
                  margin-right: 0.3em;
                }
              }
            }
          }
        }
      }
    }
  }
</style>